import { UPDATE_SEGMENTS } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (values) => (dispatch) =>
    dispatch(panelLayoutV2Actions[UPDATE_SEGMENTS](values));
